import React from 'react';

import { linker, getGetCardsQueryKey } from '@vlabs/api/point-api/client';
import { FolderPlusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useAttachCardToListTranslation } from './i18n';
import { useAttachCardsToList } from './useAttachCardsToList';

const displayName = 'AttachCardsToListButton';
const testid = buildTestid(displayName);

export interface AttachCardsToListButtonProps extends
  WithDataTestid,
  ButtonProps {
  cardIds: string[];
}

export function AttachCardsToListButton({
  cardIds,
  'data-testid': dataTestId = undefined,
  ...props
}: AttachCardsToListButtonProps): React.JSX.Element {
  const { t } = useAttachCardToListTranslation();
  const { open, form } = useAttachCardsToList(cardIds, linker, getGetCardsQueryKey());

  return (
    <React.Fragment>
      {form}
      <Button
        icon={<FolderPlusIcon />}
        kind="primary"
        onClick={open}
        size="small"
        variant="flat-inverted"
        {...testid(dataTestId)}
        {...props}
      >
        {t('attach_button')}
      </Button>
    </React.Fragment>
  );
}
